import React from 'react'
import {Button, Dialog} from '@startlibs/components'
import {WithForm,Errors} from '@startlibs/form'
import {formFetch} from '@startlibs/utils'
import {useNotificationRef} from '../../../components/Notifications'
import {StudyCard} from '../StudyCard'

export const MarkAsReadDialog = ({closeDialog,refreshList,url,study}) => {
  const [,setNotification] = useNotificationRef()

  const status = study.tools.report.reportStatus
  const canMarkAsRead = status == "Draft" || status == "Pending"
  const canUnMarkAsRead = status == "Unknown"

  return<WithForm
    skipDom
    action={formFetch("/StudyMarkAsRead.php")}
    values={{
      id: study.study.id,
      patientID: study?.patient?.patientID,
      patientName: study?.patient?.patientName,
      studyUID: study?.study?.iuid,
      studyDescription: study?.study?.studyDescription,
      mark: canMarkAsRead ? 1 : 0
    }}
    alwaysSave
    onSuccess={() => refreshList().then(closeDialog).then(() => setNotification(`Study successfully moved to ${canMarkAsRead ? 'All cases' : 'Open cases'}.`))}
  >{form =>
    <Dialog
      closeDialog={closeDialog}
      // title="Mark as read confirmation"
      title={canMarkAsRead ? "Mark as read confirmation" : "Unmark as read confirmation"}
      footer={<>
        <Button onClick={closeDialog}>Cancel</Button>
        <Button highlight onClick={form.willSubmitForm} type="submit" isLoading={form.isLoading}>
          {canMarkAsRead ? "Yes, mark as read" : "Yes, unmark as read"}
        </Button>
      </>}
    >
      <StudyCard study={study}/>
      {canMarkAsRead ? <>
        <p>By marking this study as read it will be removed from the 'Open cases' list, but you will still be
          able to access it by opening the 'All cases' tab.</p>
        <p>Are you sure you want to mark this study as read?</p>
      </> : <>
        <p>By unmarking this study as read it will be listed in the 'Open cases' list.</p>
        <p>Are you sure you want to unmark this study as read?</p>
      </>}
      <Errors/>
    </Dialog>
  }</WithForm>

}
